export const VideoReelSliderWidgetId = 'VideoReelSliderWidget';

export enum VideoReelSliderWidgetAttributes {
  TITLE = 'title',
  ELEMENT_ID = 'elementId',
  TEXT = 'text',
  VIDEOS = 'videos',
}
